module.exports = __webpack_public_path__ + "3598ff218ef90f78247442e83d7f4051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzak-7.jpg
// module id = 1189
// module chunks = 0